import consumer from "./consumer"

export class Issue {

  constructor (issue_id) {
    const display_people = document.querySelector('meta[name="multi-user-edit-inform"]')?.content
    const changes_from_others = document.querySelector('meta[name="multi-user-edit-change"]')?.content
    const colors = [ 'bg-green-500', 'bg-orange-500', 'bg-teal-500', 'bg-cyan-500', 'bg-sky-500', 'bg-indigo-500', 'bg-lime-500' ]

    if (!issue_id) return

    return consumer.subscriptions.create({
      channel: 'IssueChannel',
      issue_id: issue_id
    }, {
      connected () {},
      disconnected () {},

      received (response) {
        const login = response.data.find(e => Object.keys(e)[ 0 ] == 'login')[ 'login' ]
        const random_id = response.data.find(e => Object.keys(e)[ 0 ] == 'random_id')[ 'random_id' ]
        const form = this.find_form(random_id)

        if (!form) return

        if (parseInt(display_people) > 0) this.find_and_change_person(form, login)
        if (parseInt(changes_from_others) > 0) this.update_fields(form, response.data)
      },

      send_changed_data (data) {
        this.perform('changed_data', data)
      },

      find_form (random_id) {
        let form = null

        document.querySelectorAll('#issues-container .issue-edit').forEach((f) => {
          const form_random_id = f.dataset.randomId
          const form_issue_id = f.dataset.issueId

          if (!form_issue_id && form_issue_id != issue_id) return
          if (!form_random_id && form_random_id == random_id) return

          form = f
        })
        return form
      },

      update_fields(form, fields) {
        fields.forEach( f => {
          const field = Object.keys(f)
          const values = Object.values(f)

          if (field[0].indexOf('issue') < 0) return

          const form_field = form.querySelector(`input[name="${ field }"]`) ||
                             form.querySelector(`select[name="${ field }"]`) ||
                             form.querySelector(`textarea[name="${ field }"]`)

          form_field.value = values[0]
        })
      },

      //
      // find the online_logins, check if a shortname ist still there
      // and add the new one
      //
      find_and_change_person (form, login) {
        let user_cnt = 0
        let found = false

        const logins_online = form.querySelector('.logins_online')
        if (!logins_online) return

        logins_online.querySelectorAll('div').forEach((p) => {
          user_cnt++
          if (p.innerHTML == login[ 'shortname' ]) {
            found = true
          }
        })
        if (!found) {
          const person = this.build_person(login[ 'name' ], login[ 'shortname' ], user_cnt)
          logins_online.insertAdjacentElement('beforeend', person)
        }
      },

      //
      // build div block for user
      //
      build_person (name, shortname, user_cnt) {
        const person = document.createElement('div')

        person.classList.add('inline-block', 'ring-2', 'ring-white', 'rounded-full', 'text-center',
          'min-w-8', 'min-h-8', 'py-2', 'px-1.5', 'text-xs',
          'text-stone-50', colors[ user_cnt % colors.length ] )
        person.innerHTML = shortname
        person.setAttribute('alt', `${name} hat Daten zu diesem Fall bearbeitet`)
        person.setAttribute('title', `${name} hat Daten zu diesem Fall bearbeitet`)
        return person
      }
    })
  }
}
